import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      {/* Top blue header with logo */}
      <div className="bg-gradient-to-b from-[#1E40AF] to-[#0071ce] py-2">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center">
            <img src="/images/logo.png" alt="M-Mart+" className="h-6" />
          </div>
        </div>
      </div>

      {/* Main footer section with light blue background */}
      <div className="bg-[#e8f1fa] py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Contact Us */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <span className="text-[#f9a825] mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </span>
                  <span className="text-gray-700">0814 826 8019</span>
                </li>
                <li className="flex items-center">
                  <span className="text-[#f9a825] mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </span>
                  <Link to="/help" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Contact Us
                  </Link>
                </li>
                <li className="flex items-start">
                  <span className="text-[#f9a825] mr-2 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </span>
                  <span className="text-gray-700">
                     Shalom Rd, Amuwo Odofin, 102102, Lagos
                  </span>
                </li>
              </ul>
            </div>

            {/* Areas We Serve */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Areas We Serve</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/locations/amuwo-odofin" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Amuwo Odofin
                  </Link>
                </li>
                <li>
                  <Link to="/locations/festac" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Festac
                  </Link>
                </li>
                <li>
                  <Link to="/locations/lagos-island" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Lagos Island
                  </Link>
                </li>
                <li>
                  <Link to="/locations/ikoyi" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Ikoyi
                  </Link>
                </li>
                <li>
                  <Link to="/locations/victoria-island" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Victoria Island
                  </Link>
                </li>
                <li>
                  <Link to="/locations/lekki-phase-1" className="text-gray-700 hover:text-blue-600 transition-colors">
                    Lekki Phase 1
                  </Link>
                </li>
                <li className="pt-2">
                  <Link to="/locations" className="text-blue-600 hover:underline font-semibold">
                    View All Areas →
                  </Link>
                </li>
              </ul>
            </div>

            {/* Payment method */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Payment method</h3>
              <div className="flex flex-wrap gap-5">
                <img src="/images/payment/visa.png" alt="Visa" loading="lazy" className="h-8 object-contain" />
                <img src="/images/payment/master.png" alt="Mastercard" loading="lazy" className="h-8 object-contain" />
                <img src="/images/payment/banktransfer.png" alt="Bank Transfer" loading="lazy" className="h-8 object-contain" />
              </div>
            </div>

            {/* Download App */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Download App</h3>
              <div className="space-y-3">
                <a href="https://play.google.com/store/apps/details?id=com.mmartplus.app&hl=en-US" target="_blank" rel="noopener noreferrer" className="block mb-2">
                  <img src="/images/app/playstore.png" alt="Google Play Store" loading="lazy" className="h-10" />
                </a>
                <a href="https://apps.apple.com/us/app/m-mart/id6751410231" target="_blank" rel="noopener noreferrer" className="block">
                  <img src="/images/app/appstore.png" alt="App Store" loading="lazy" className="h-10" />
                </a>
              </div>
              
              {/* Our Socials */}
              <div className="mt-6">
                <h3 className="font-semibold text-lg mb-3">Our Socials</h3>
                <div className="flex space-x-3">
                  <a href="https://www.facebook.com/profile.php?id=61572614230491" target="_blank" rel="noopener noreferrer" className="text-[#1877f2] hover:opacity-80" aria-label="Facebook">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                    </svg>
                  </a>
                  <a href="https://twitter.com/mmartplus" target="_blank" rel="noopener noreferrer" className="text-[#1da1f2] hover:opacity-80" aria-label="Twitter/X">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                  </a>
                  <a href="https://www.instagram.com/_mmartplus" target="_blank" rel="noopener noreferrer" className="text-[#e4405f] hover:opacity-80" aria-label="Instagram">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.048 1.055-.058 1.37.058 4.041v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                    </svg>
                  </a>
                  <a href="https://www.youtube.com/@mmartplus" target="_blank" rel="noopener noreferrer" className="text-[#ff0000] hover:opacity-80" aria-label="YouTube">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                    </svg>
                  </a>
                  <a href="https://www.tiktok.com/@mmartplus" target="_blank" rel="noopener noreferrer" className="text-[#00f2ea] hover:opacity-80" aria-label="TikTok">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/in/mmart-plus-6892593a6" target="_blank" rel="noopener noreferrer" className="text-[#0077b5] hover:opacity-80" aria-label="LinkedIn">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Feedback button */}
          <div className="flex justify-center mt-8">
            <a 
              href="https://wa.me/2348148268019?text=I%20have%20feedback" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-[#1E40AF] to-[#0071ce] hover:from-[#1e3a8a] hover:to-[#005da6] text-white px-6 py-2 rounded-md transition duration-300 flex items-center"
              aria-label="Give feedback via WhatsApp"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Give Us Feedback
            </a>
          </div>
        </div>
      </div>
      
      {/* Copyright bar */}
      <div className="bg-gradient-to-b from-[#1E40AF] to-[#0071ce] text-white py-3">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm">
          <div className="flex space-x-4 mb-2 md:mb-0">
            <Link to="/about" className="hover:underline">About Us</Link>
            <Link to="/privacy" className="hover:underline">Privacy</Link>
            <Link to="/terms" className="hover:underline">Terms and Condition</Link>
            <Link to="/refund" className="hover:underline">Refund Policy</Link>
          </div>
          <div>
            {currentYear} M-Mart Plus. All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
};
